import type { PageLoadScenarioRegistry } from '@ms/yammer-scenario-telemetry';

/**
 * yammer-web's registry of pages measured for page-load QoS, keyed by route `PageName`. It sits
 * alongside the route table (`loadablePageRoutes.ts`) where those `PageName`s are declared: this is
 * the one place a feature crew edits to onboard a web page to scenario-based QoS. Add an entry
 * mapping the page to its navigation scenario, and the bridge (see `pageLoadScenarioBridge`) starts
 * emitting that scenario for the page's navigation -> content-shown window.
 *
 * Several page names may map onto one scenario (e.g. a community's feed tabs all represent
 * `open_community_feed`); that many-to-one grouping is web routing domain knowledge and lives here,
 * in the app, rather than in the app-agnostic scenario-telemetry package.
 *
 * `source` is deliberately omitted: these pages are reachable from many entry points (feed,
 * search, notifications, deep links), so a fixed destination-based `source` would misattribute the
 * navigation origin. Only set `source` on an entry whose page has a single, reliable entry point.
 *
 * `HomeFeed` is intentionally absent: it is already instrumented in place via
 * `useStartOpenHomeFeedScenario` (also gated on `ScenarioBasedQosTelemetry`), so registering it
 * here would start `open_home_feed` twice. Onboard it here only once that legacy wiring is removed.
 */
export const pageLoadScenarioRegistry: PageLoadScenarioRegistry = {
  GroupAll: { name: 'open_community_feed' },
  GroupUnseen: { name: 'open_community_feed' },
  GroupUnseenThreadStarters: { name: 'open_community_feed' },
  Thread: { name: 'open_conversation' },
  QuestionThread: { name: 'open_conversation' },
};
